import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Gomukhasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Gomukhasana.title1"), context: t("Gomukhasana.context1") },
      { title: t("Gomukhasana.title2"), context: t("Gomukhasana.context2") },
      { title: t("Gomukhasana.title3"), context: t("Gomukhasana.context3") },
      { title: t("Gomukhasana.title4"), context: t("Gomukhasana.context4") },
      { title: t("Gomukhasana.title5"), context: t("Gomukhasana.context5") },
      { title: t("Gomukhasana.title6"), context: t("Gomukhasana.context6") },
      { title: t("Gomukhasana.title7"), context: t("Gomukhasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Gomukhasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Gomukhasana.mp4'}
                title="Description"
                context={t("Gomukhasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Gomukhasana
